

import React, { memo } from 'react';
import moment from 'moment';
import { Image, Checkbox, Text } from '../../../../../../../../../../../ui-kit';
import { getUser } from '../../../../../../../../../../../common/utils';
import '../styles/_comment-header.scss';







function Header({ comment: {
    updatedAt,
    isResolved,
    createdByUser
  },
  onUpdateCheckbox,
  canResolveComment
}) {
  const formattedTime = moment(updatedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('YYYY/MM/DD [at] h:mm a');
  const { name, imageUrl, isUser } = getUser(createdByUser);

  return (
    <div className="header">
      <div className="header__profile-image-wrapper">
        <Image
          height="40px"
          width="40px"
          imageUrl={imageUrl}
          placeholderText={name}
          placeholderTextSize={15}
          circular
          backgroundSize="cover" />

        <div className="header__profile-image-wrapper__text">
          <Text noMargin>
            {isUser ? 'You' : name}
          </Text>
          <Text placeholder noMargin>
            {formattedTime}
          </Text>
        </div>
      </div>
      {
      canResolveComment ?

      <Checkbox
        checked={isResolved}
        onChange={onUpdateCheckbox} /> :


      null}

    </div>);

}

export default memo(Header);